export const DictionaryActionTypes = {
  SET_PHONE_CODE: 'SET_PHONE_CODE',
  SET_CIVILIAN_PREFIX: 'SET_CIVILIAN_PREFIX',
  SET_GENDER: 'SET_GENDER',
  SET_MAKE: 'SET_MAKE',
  SET_MARITAL_STATUS: 'SET_MARITAL_STATUS',
  SET_IDENTIFICATION_DOCUMENT_TYPE: 'SET_IDENTIFICATION_DOCUMENT_TYPE',
  SET_NATIONALITY_ALL: 'SET_NATIONALITY_ALL',
};
